import axios, { AxiosPromise } from 'axios';
import { IOrchard } from '../../../@types/model/masterData/orchard/orchard';
import qs from 'qs';
import { IOrchardUpsert } from '../../../@types/model/masterData/orchard/orchardUpsert';

export default class OrchardHttpService {
    public static getOrchardData(organizationIds : Array<number>) : AxiosPromise<Array<IOrchard>> {
        return axios.get(`${API_URL}/v1/Orchard/GetAllWeb`, {
            params: {
                organizationIds,
            },
            paramsSerializer: qs.stringify,
        });
    }

    public static addOrUpdateOrchard(upsert : IOrchardUpsert) : AxiosPromise<IOrchard> {
        return axios.post(`${API_URL}/v1/Orchard/PostOrchard`, upsert);
    }

    public static deleteOrchard(orchardId : number) : AxiosPromise<IOrchard> {
        return axios.delete(`${API_URL}/v1/Orchard/Delete`, {
            params : { orchardId },
        });
    }
}
